import {Injectable} from '@angular/core';
import {EventTriggerService} from '@app/event/event-trigger.service';
import {AbstractPlatform} from '@app/platform/platform';
import {SettingsService} from '@app/sync/settings.service';
import {SyncServiceBase} from '@app/sync/sync.service.base';
import {ControllerClientServiceBase} from '@app/shared/controller-client.service.base';
import {TimeService} from '@app/shared/time.service';

@Injectable()
export class ControllerClientService extends ControllerClientServiceBase {

    constructor(
        platform: AbstractPlatform,
        settings: SettingsService,
        sync: SyncServiceBase,
        timeService: TimeService,
        private readonly eventTrigger: EventTriggerService,
    ) {
        super(platform, settings, sync, timeService);
    }

    connect(): void {
        super.connect();
        const connection = this.connection;

        if (!connection) {
            return;
        }

        const register = (path: string, handler: Function) =>
            connection.register(`${this.url}.${path}`, handler);

        register('trigger_event', this.eventTrigger.triggerEventById.bind(this.eventTrigger));
    }
}
